import PropTypes from 'prop-types';
import React from 'react';
import PanelStandard from './panel-standard';
import PanelWithSubHeader from './panel-with-sub-header';

const Panel = props => {
  const {
    subHeader,
    subHeaderContent,
  } = props;

  const isStandardPanel = !subHeader && subHeaderContent === null;

  return (
    <>
      { isStandardPanel
        ? <PanelStandard props={props} />
        : <PanelWithSubHeader props={props} />
      }
    </>
  );
};

Panel.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  header: PropTypes.bool,
  headerContent: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  subHeader: PropTypes.bool,
  subHeaderContent: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  panelBodyStyles: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  panelWrapperStyles: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  errorState: PropTypes.bool,
  completedState: PropTypes.bool
};

Panel.defaultProps = {
  children: null,
  header: false,
  headerContent: null,
  subHeader: false,
  subHeaderContent: null,
  panelBodyStyles: null,
  panelWrapperStyles: null,
  errorState: false,
  completedState: false
};

export default Panel;
